import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapBufferHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Buffer;
    }
}

//# sourceMappingURL=WrapBufferHelper.js.map
